// extracted by mini-css-extract-plugin
export default {"policyContainer":"PrivatePolicy_policyContainer__I2GfU","policyContent":"PrivatePolicy_policyContent__jF8JL","description":"PrivatePolicy_description__iUsR9"};